import React, { useState, useEffect } from "react";
import { Stack, Typography, Autocomplete, TextField } from "@mui/material";
import OverridesShell from "../Shell/OverridesShell.jsx";
import useFetchAgentsOptions from "../../../sharedhooks/Agents/useFetchAllAgents.js";

export default function AdminOverrides() {
	const [selectedAgent, setSelectedAgent] = useState(null);
	const { agents, loading: agentOptionsLoading } = useFetchAgentsOptions();

	const currentAgent = selectedAgent ?? agents?.[0] ?? null;

	const headerSlot = (
		<Stack
			direction={{ xs: "column", sm: "row" }}
			alignItems={{ xs: "flex-start", sm: "center" }}
			spacing={{ xs: 0.75, sm: 2 }}
			width={{ xs: "100%", lg: "auto" }}
		>
			<Typography fontWeight={600} sx={{ fontSize: { xs: 13, sm: 14 }, whiteSpace: "nowrap" }}>
				Current Agent:
			</Typography>
			<Autocomplete
				size="small"
				options={agents || []}
				loading={agentOptionsLoading}
				value={currentAgent}
				onChange={(e, newValue) => setSelectedAgent(newValue)}
				getOptionLabel={(option) => option?.display_name || ""}
				isOptionEqualToValue={(option, value) => option?.ID === value?.ID}
				sx={{
					width: { xs: "100%", sm: 220, md: 250 },
					"& .MuiButtonBase-root": {
						backgroundColor: "transparent",
						"&:hover": { color: "#1D54A2" },
					},
				}}
				slotProps={{
					popper: {
						sx: {
							"& .MuiAutocomplete-paper": { width: "inherit !important" },
						},
					},
				}}
				renderInput={(params) => (
					<TextField
						{...params}
						placeholder="Select agent"
						sx={{
							"& .MuiInputBase-input": {
								padding: { xs: "6px 10px", sm: "8.5px 14px" },
								fontSize: { xs: 13, sm: 14 },
							},
							"& fieldset": { borderColor: "#4E4E4E !important" },
							"&:hover fieldset": { borderColor: "#4E4E4E !important" },
							"&.Mui-focused fieldset": { borderColor: "#4E4E4E !important" },
							"& .MuiAutocomplete-input": { border: "none !important" },
						}}
					/>
				)}
			/>
		</Stack>
	);

	return <OverridesShell agentId={currentAgent?.ID} headerSlot={headerSlot} agentLoading={agentOptionsLoading} />;
}
